import CircularProgress from '@mui/material/CircularProgress';
import UnavailableIconImage from 'assets/images/UnavailableIcon.jpg';
import { getMatchScoreColor } from 'view/pages/profile/components/JobPostsListItem';
import { Button } from 'view/components';
import { useNavigate } from 'react-router';
import { useContextSelector as useCS } from 'use-context-selector';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { RolesEnum } from 'infrastructure/enums/RolesEnum';
import { useMediaQuery } from '@mui/material';
import { theme } from 'view/themes/theme';
import { ArrowBack } from '@mui/icons-material';
import * as S from './styled';

const ChatMessagesHeader = ({ chatInfoData, setIsChatOpen }) => {
  const navigate = useNavigate();
  const matches = useMediaQuery(theme.breakpoints.down('tablet'));
  const matchesLaptop = useMediaQuery(theme.breakpoints.down('laptop'));

  const { role } = useCS(GlobalConfigContext, globalConfigSelectors.userData);
  const avatarLink =
    role?.name === RolesEnum.JOB_SEEKER
      ? chatInfoData?.owner?.photo?.link
      : chatInfoData?.participant?.photo?.link;
  const score =
    role?.name === RolesEnum.JOB_SEEKER
      ? chatInfoData?.scoreForJobSeeker
      : chatInfoData?.scoreForRecruiter;

  const getInfoJobTitle = () => {
    return role?.name === RolesEnum.JOB_SEEKER ? (
      <S.CandidateListItemHeadingInfoTitle>
        {chatInfoData?.jobPostTitle || 'No Job Title'} at{' '}
        {chatInfoData?.jobPostCompany || 'No Company'}
      </S.CandidateListItemHeadingInfoTitle>
    ) : (
      <S.CandidateListItemHeadingInfoTitle>
        {chatInfoData?.participant?.profile?.jobTitle || 'No Job Title'}{' '}
        <span>{chatInfoData?.participant?.userName || 'No user name'}</span>
      </S.CandidateListItemHeadingInfoTitle>
    );
  };

  const getInfoSalary = () => {
    return role?.name === RolesEnum.JOB_SEEKER ? (
      <S.CandidateListItemHeadingInfoSalary>
        {!chatInfoData?.jobPostSalaryMin && !chatInfoData?.jobPostSalaryMax
          ? 'Salary not specified'
          : `$${chatInfoData?.jobPostSalaryMin.toLocaleString()} - $${chatInfoData?.jobPostSalaryMax.toLocaleString()}`}
      </S.CandidateListItemHeadingInfoSalary>
    ) : (
      <S.CandidateListItemHeadingInfoSalary>
        {!chatInfoData?.participant?.profile?.salaryMin &&
        !chatInfoData?.participant?.profile?.salaryMax
          ? 'Salary not specified'
          : `$${chatInfoData?.participant?.profile?.salaryMin.toLocaleString()} - $${chatInfoData?.participant?.profile?.salaryMax.toLocaleString()}`}
      </S.CandidateListItemHeadingInfoSalary>
    );
  };

  const onButtonClick = () => {
    return role?.name === RolesEnum.JOB_SEEKER
      ? navigate(`/profile/view-job-post?id=${chatInfoData?.jobPostId}&matchScore=${score || 0}`)
      : navigate(
          `/candidates/candidate-profile?id=${chatInfoData?.participant?.profile?.profileId}&matchScore=${score || 0}`
        );
  };

  const getMatchPercent = () => {
    return role?.name === RolesEnum.JOB_SEEKER ? (
      <S.CandidateListItemHeadingInfoSalary
        style={{ color: '#444444', fontSize: matches ? '10px' : '14px' }}
      >
        {Math.floor(score)}% match
      </S.CandidateListItemHeadingInfoSalary>
    ) : (
      <S.CandidateListItemHeadingInfoSalary
        style={{ color: '#444444', fontSize: matches ? '10px' : '14px' }}
      >
        {Math.floor(score)}% match for {chatInfoData?.jobPostTitle}
      </S.CandidateListItemHeadingInfoSalary>
    );
  };

  const imgStyles = matches ? { width: '48px', height: '48px' } : { width: '72px', height: '72px' };

  const getButtonText = () => {
    if (role?.name === RolesEnum.JOB_SEEKER && matches) return 'View';
    if (role?.name === RolesEnum.JOB_SEEKER && !matches) return 'View Job Post';
    if (role?.name === RolesEnum.RECRUITER && matches) return 'View';
    if (role?.name === RolesEnum.RECRUITER && !matches) return 'View Profile';
    return '';
  };

  return (
    <S.ChatMessagesHeader>
      <S.CandidateListItemHeadingInfo>
        {matchesLaptop ? (
          <div
            onClick={() => {
              return setIsChatOpen(false);
            }}
          >
            <ArrowBack />
          </div>
        ) : null}

        <div style={{ ...imgStyles, position: 'relative' }}>
          {avatarLink && chatInfoData?.status?.name === 'Active' ? (
            <img src={avatarLink} alt="avatar" style={{ ...imgStyles }} />
          ) : null}
          {chatInfoData?.status && chatInfoData?.status?.name !== 'Active' ? (
            <img src={UnavailableIconImage} alt="UnavailableIcon" style={{ ...imgStyles }} />
          ) : null}
          {score && chatInfoData?.status?.name === 'Active' ? (
            <div
              style={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            >
              <CircularProgress
                variant="determinate"
                value={score > 100 ? 100 : score}
                style={{
                  ...imgStyles,
                  color: getMatchScoreColor(score),
                }}
              />
            </div>
          ) : null}
        </div>

        {chatInfoData?.status?.name === 'Active' ? (
          <S.CandidateListItemHeadingInfoTexts>
            {getInfoJobTitle()}
            {getInfoSalary()}
            {score ? getMatchPercent() : null}
          </S.CandidateListItemHeadingInfoTexts>
        ) : (
          <S.CandidateListItemHeadingInfoTexts>
            <S.CandidateListItemHeadingInfoTitle>
              {chatInfoData?.status?.name}
            </S.CandidateListItemHeadingInfoTitle>
          </S.CandidateListItemHeadingInfoTexts>
        )}
      </S.CandidateListItemHeadingInfo>
      {chatInfoData?.status?.name === 'Active' ? (
        <Button
          variant="outlined"
          text={getButtonText()}
          style={{
            padding: matches ? '0' : '10px 20px',
            width: matches ? 'max-content' : '160px',
            minWidth: matches ? 'max-content' : '160px',
            height: matches ? 'max-content' : '40px',
            minHeight: matches ? 'max-content' : '40px',
            fontSize: matches ? '12px' : '14px',
            border: matches ? 'none' : '1px solid',
            borderColor: matches ? 'transparent' : '#663497',
          }}
          onClick={onButtonClick}
        />
      ) : null}
    </S.ChatMessagesHeader>
  );
};

export default ChatMessagesHeader;
